<div class="container">
	<nb-card class="main-content">
		<h1 class="title">Rivendosni fjalëkalimin</h1>
		<p class="paragraph">
			Rivendosni fjalëkalimin tuaj.
		</p>

		<form [formGroup]="resetPasswordForm" class="reset-form">
			<div class="pasword-container">
				<label class="short-paragraph mb-2">
					Fjalëkalimi i ri
				</label>
				<input
					class="input"
					nbInput
					type="password"
					placeholder="Fjalëkalimi i ri"
					formControlName="password"
					[type]="showPasswordArgs[0] ? 'text' : 'password'"
				/>
				<nb-icon
					class="eye-icon"
					[icon]="showPasswordArgs[0] ? 'eye' : 'eye-off'"
					(click)="showPassword(0)"
				></nb-icon>

				<span *ngIf="submitted && passwordError" class="error-message"
					>Fjalëkalimi duhet të përmbaj së paku 8 karaktere!</span
				>
			</div>

			<div class="pasword-container">
				<label class="short-paragraph mb-2" for="password">
					Konfirmo Fjalëkalimin
				</label>
				<input
					class="input"
					nbInput
					type="password"
					formControlName="confirmPassword"
					placeholder="Konfirmo Fjalëkalimin"
					[type]="showPasswordArgs[1] ? 'text' : 'password'"
				/>
				<nb-icon
					class="eye-icon"
					[icon]="showPasswordArgs[1] ? 'eye' : 'eye-off'"
					(click)="showPassword(1)"
				></nb-icon>

				<span *ngIf="submitted && confirmPasswordError" class="error-message"
					>Fjalëkalimi duhet të përmbaj së paku 8 karaktere!</span
				>
				<span
					*ngIf="resetPasswordForm.valid && mismatchPasswords"
					class="error-message"
					>Fjalëkalimet nuk përputhen!</span
				>
			</div>

			<button
				nbButton
				[nbSpinner]="requesting"
				[disabled]="requesting"
				nbSpinnerStatus="control"
				(click)="emitForm()"
				type="submit"
				class="blue-button"
			>
				Rivendos
			</button>
		</form>
	</nb-card>
</div>
